import React, {useContext, useEffect, useState} from 'react';
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@mui/material';
import {DispatchContext, StateContext} from '../../../store';
import Moment from 'react-moment';
import {catalogueApi} from '../../../services/CatalogueServices';
import {useNavigate} from 'react-router';
import IconButton from '@mui/material/IconButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import RejectArtefact from './RejectArtefact';
import KeywordSearch from '../../../common/SearchComponent/KeywordSearch';

export default function NewCatalogueList({role, meta, setMeta}) {
  const dispatch = useContext(DispatchContext);
  const navigate = useNavigate();
  const [querySearch, setQuerySearch] = useState('');
  const [show, setShow] = useState(false);
  const [artefacts, setArtefacts] = useState([]);
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem('catalogue_list_page');
    return savedPage ? parseInt(savedPage, 10) : 1;
  });
  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const savedRowsPerPage = localStorage.getItem('catalogue_list_rows_per_page');
    return savedRowsPerPage ? parseInt(savedRowsPerPage, 10) : 10;
  });
  const curator = role?.id === 2;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedArtefactId, setSelectedArtefactId] = React.useState(null);
  const open = Boolean(anchorEl);

  const asText = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'object') {
      return value?.name || value?.code || value?.description || String(value?.id || '-');
    }
    const str = String(value);
    return str?.trim?.() ? str : '-';
  };

  useEffect(() => {
    getUserList();
  }, [querySearch, page, rowsPerPage]);

  const getUserList = () => {
      catalogueApi('get', null, {search: querySearch, active_task: 'true', page: page, per_page: rowsPerPage}).then(res => {
        setArtefacts(res?.data);
        setMeta(res?.meta);
      })
  }

  const handleChangePage = (event, newPage) => {
    dispatch({type: 'IS_NOT_LOADING', payload: false});
    const updatedPage = newPage + 1;
    setPage(updatedPage);
    localStorage.setItem('catalogue_list_page', updatedPage.toString());
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(1);
    localStorage.setItem('catalogue_list_rows_per_page', newRowsPerPage.toString());
    localStorage.setItem('catalogue_list_page', '1');
  };

  const editUser = () => {
    navigate(`/management/catalogue-artefacts/create/?id=${selectedArtefactId}&isEdit=true`)
  }

  const artefactDetail = (id) => {
    navigate(`/management/catalogue-artefacts/${id}`)
  }

  const handleReject = () => {
    setShow(true);
    handleClose();
  }

  const handleCloseAction = () => {
    setShow(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event, artefactId) => {
    setAnchorEl(event.currentTarget);
    setSelectedArtefactId(artefactId);
  };

  const handleSearchChange = (value) => {
    setQuerySearch(value);
  }

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item sm={4} xs={12} sx={{mb: 1}}>
          <KeywordSearch placeholder={'Search...'} onChange={(value) => handleSearchChange(value)}/>
        </Grid>
      </Grid>
      <TableContainer className={'box-shadow'} component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{color: '#B3B3B3', width: 20}}>Sl.No</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Date of Entry</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Accession No.</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Object Name</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Materials</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Place of Origin</TableCell>
              <TableCell align="left" sx={{color: '#B3B3B3'}}>Cataloged By</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {artefacts?.length > 0 && artefacts?.map((artefact, index) => (
              <TableRow hover key={index}>
                <TableCell align="left" sx={{color: '#3D3D3D', width: 20}} onClick={() => artefactDetail(artefact?.id)}>
                  {index + 1}
                </TableCell>
                <TableCell sx={{color: '#3D3D3D'}} onClick={() => artefactDetail(artefact?.id)}>
                  <Moment format={'ll'}>{artefact?.date_of_entry || '-'}</Moment>
                </TableCell>
                <TableCell align="left" sx={{color: '#3D3D3D'}} onClick={() => artefactDetail(artefact?.id)}>
                  {asText(artefact?.accession_no || artefact?.accession_no_legacy)}
                </TableCell>
                <TableCell align="left" sx={{color: '#3D3D3D'}} onClick={() => artefactDetail(artefact?.id)}>
                  {artefact?.object_name || '-'}
                </TableCell>
                <TableCell align="left" sx={{color: '#3D3D3D'}} onClick={() => artefactDetail(artefact?.id)}>
                  {asText(artefact?.material)}
                </TableCell>
                <TableCell align="left" sx={{color: '#3D3D3D'}} onClick={() => artefactDetail(artefact?.id)}>
                  {asText(artefact?.place_of_origin)}
                </TableCell>
                <TableCell align="left" sx={{color: '#3D3D3D'}} onClick={() => artefactDetail(artefact?.id)}>
                  {artefact?.user_name || '-'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 100]}
        page={page - 1}
        rowsPerPage={rowsPerPage}
        component="div"
        count={meta?.total}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {show &&
      <RejectArtefact
        open={show}
        handleAction={handleCloseAction}
        catalogueId={selectedArtefactId}
        roleId={role?.id}
        taskPool={[]}
      />}
    </div>
  );
}